<div
  class="news-card-container"
  (click)="onShowMore($event)"
>
  <div class="news-card-image">
    <img
      [src]="data?.imageUrl || 'wealth-assets/icons/speaker.svg'"
      alt=""
    />
  </div>
  <div class="news-card-info">
    <div class="news-card-title">
      <span [innerHTML]="data?.title"></span>
    </div>
    <div class="news-card-date">
      <span>{{ data?.date | jalaliDate }}</span>
      <div class="news-card-more">
        <span>بیشتر </span>
        <img src="wealth-assets/icons/chevron-left-gray.svg" />
      </div>
    </div>
  </div>
</div>
